var _circle, _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 77,
    viewBox: "0 0 96 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 38.2559,
    r: 24,
    fill: "#EF183E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27060_4786)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.8898,
    cy: 38.2551,
    r: 34.2551,
    fill: "#FCFDFC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8906 28.2559H62.8906H50.8906ZM62.8906 48.2559V42.2559V48.2559ZM56.8906 48.2559H56.9106H56.8906ZM50.8906 48.2559H50.9106H50.8906ZM50.8906 42.2559H50.9106H50.8906ZM56.8906 42.2559H56.9106H56.8906ZM62.8906 36.2559H62.9106H62.8906ZM56.8906 36.2559H56.9106H56.8906ZM50.8906 36.2559H50.9106H50.8906ZM46.8906 56.2559H66.8906C67.9515 56.2559 68.9689 55.8344 69.7191 55.0843C70.4692 54.3341 70.8906 53.3167 70.8906 52.2559V24.2559C70.8906 23.195 70.4692 22.1776 69.7191 21.4274C68.9689 20.6773 67.9515 20.2559 66.8906 20.2559H46.8906C45.8298 20.2559 44.8123 20.6773 44.0622 21.4274C43.3121 22.1776 42.8906 23.195 42.8906 24.2559V52.2559C42.8906 53.3167 43.3121 54.3341 44.0622 55.0843C44.8123 55.8344 45.8298 56.2559 46.8906 56.2559Z",
    stroke: "#001234",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_27060_4786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1255 29.3809H39.125L15.125 53.3804L15.1255 29.3809Z",
    fill: "#001234"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27060_4786",
    x: 18.6348,
    y: 0,
    width: 76.5098,
    height: 76.5098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27060_4786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27060_4786",
    x: 11.125,
    y: 25.3809,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27060_4786"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.1f0e30c08952528c28ef6f735697088f.svg";
export { ForwardRef as ReactComponent };